<template>
  <div class="live-commentary-suspended-wrap">
    <transition name="slide-left">
      <div
        v-show="type===1"
        class="live-commentary-suspended"
      >
        <MsgVoucher
          :data="data"
          :is-fixed="true"
        />
      </div>
    </transition>

    <transition name="slide-left">
      <div
        v-if="type===2"
        class="live-commentary-suspended"
      >
        <MsgStatistic :hide-left="true" />
      </div>
    </transition>
  </div>
</template>

<script>
import MsgStatistic from './MsgStatistic.vue'
import MsgVoucher from './MsgVoucher.vue'

export default {
  name: 'MsgFixSuspended',
  components: {
    MsgStatistic,
    MsgVoucher
  },
  props: {
    type: {
      type: Number,
      default: 0
    },
    data: {
      type: Object,
      default: () => {
        return {}
      }
    }
  }
}
</script>

<style lang="less">
@import url("~wap/common/style/variable.less");

.live-commentary-suspended-wrap {
  position: fixed;
  z-index: 10;
  right: 0;
  bottom: 70/@rem;
  left: 0;
  width: 100%;
  max-width: 750px;
  margin: auto;

  .slide-left-enter-active,
  .slide-left-leave-active {
    transition: all 0.5s linear;
  }

  .slide-left-enter {
    opacity: 0;
    transform: translateX(-110%);
  }

  .slide-left-leave-to {
    opacity: 0;
    transform: translateX(110%);
  }
}

.live-commentary-suspended {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  width: 296/360 * 100%;
  border-radius: 4px;
  margin: auto;
  box-shadow: 0 -15/@rem 30/@rem 10/@rem @dark;
}

</style>
